import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useState } from 'react'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { AnimalsEnteredByDateDto } from '../../../interactors/gen/backendClient'
import { colors } from '../../theme'

interface AssociationDashboardEvolutionProps {
  entryData: AnimalsEnteredByDateDto[]
  exitData: AnimalsEnteredByDateDto[]
}

export const AssociationDashboardEvolution: React.FC<AssociationDashboardEvolutionProps> = ({
  entryData,
  exitData,
}) => {
  const [graphData, setGraphData] = useState<AnimalsEnteredByDateDto[]>(entryData)
  const [buttonValue, setButtonValue] = useState<boolean>(true)

  const handleToggleChange = (event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    event.stopPropagation()
    if (newValue === 'entry') {
      setButtonValue(true)
      setGraphData(entryData)
    } else {
      setButtonValue(false)
      setGraphData(exitData)
    }
  }
  return (
    <>
      <Box
        marginBottom={2}
        marginTop={5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1.5}
      >
        <Typography variant="h5">Evolution des entrées et des sorties</Typography>
        <ToggleButtonGroup
          exclusive
          value={buttonValue ? 'entry' : 'exit'}
          onChange={handleToggleChange}
          aria-label="text alignment"
          sx={{
            p: 0.5,
            borderRadius: '999px',
            backgroundColor: '#F7F9FC',
            border: '1px solid rgba(122, 129, 151, 0.18)',
            '& .MuiToggleButtonGroup-grouped': {
              border: 'none',
              minWidth: 92,
              minHeight: 34,
              px: 1.5,
              borderRadius: '999px !important',
              textTransform: 'none',
              fontSize: 12.5,
              fontWeight: 700,
              color: '#5F6B85',
              '&.Mui-selected': {
                color: colors.cello,
                backgroundColor: '#FFFFFF',
                boxShadow: '0 8px 18px rgba(31, 55, 100, 0.10)',
              },
              '&.Mui-selected:hover': {
                backgroundColor: '#FFFFFF',
              },
            },
          }}
        >
          <ToggleButton value="entry" aria-label="Entrée">
            Entrée
          </ToggleButton>
          <ToggleButton value="exit" aria-label="Sortie">
            Sortie
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Grid container spacing={0} height={400}>
        {/*  <Grid item xs={12} md={2}>
          <Typography variant="h5" marginBottom={1}>
            Animaux
          </Typography>
          <List dense={false}>
            {uniqueSpecies.map((specie, index) => (
              <ListItem key={index}>
                <ListItemText primary={getReadableSpecies(specie)} />
              </ListItem>
            ))}
          </List>
          <Typography variant="h5" marginBottom={1}>
            Motif abandon
          </Typography>
          <List dense={false}>
            {uniqueReasons.map((reason, index) => (
              <ListItem key={index}>
                <ListItemText primary={getReadableTakeOverReason(reason)} />
              </ListItem>
            ))}
          </List>
        </Grid> */}
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              borderRadius: 4,
              border: '1px solid rgba(228, 232, 242, 0.9)',
              backgroundColor: '#F9FBFF',
              overflow: 'hidden',
              px: { xs: 0.5, sm: 1.5 },
              py: { xs: 1, sm: 1.5 },
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={graphData}
                margin={{
                  top: 10,
                  right: 18,
                  left: 4,
                  bottom: 6,
                }}
              >
                <CartesianGrid strokeDasharray="4 4" stroke="rgba(23, 31, 52, 0.08)" />
                <XAxis dataKey="name" tick={{ fontSize: 11, fill: '#7A8197' }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fontSize: 11, fill: '#7A8197' }} axisLine={false} tickLine={false} width={28} />
                <Tooltip
                  cursor={{ stroke: 'rgba(105, 141, 172, 0.25)', strokeWidth: 1 }}
                  contentStyle={{
                    borderRadius: 14,
                    border: '1px solid rgba(228, 232, 242, 0.9)',
                    boxShadow: '0 12px 28px rgba(22, 35, 66, 0.12)',
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="animaux"
                  name={buttonValue ? 'Entrées' : 'Sorties'}
                  stroke="#698DAC"
                  strokeWidth={2}
                  dot={{ r: 2 }}
                  activeDot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
